const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  img: {
    width: '32px',
    height: '32px',
  },
  paragraph: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  div: {
    width: '100%',
  },
  messageDiv: {
    display: 'flex',
    width: '480px',
    height: '22px',
    paddingTop: '4px',
    justifyContent: 'center',
  },
  imageDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    display: 'grid',
    gap: '8px',
  },
  message: {
    display: 'flex',
    alignItems: 'center', // Vertically centers the items
    gap: '4px', // Adds space between the text and the icon (adjust as needed)
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
  span: {
    marginRight: '4px',
  },

  link: {
    display: 'flex',
    alignItems: 'center', // Ensures the text and icon align properly
    textDecoration: 'none', // Optional: Remove underline if undesired
    color: 'var(--mcg-blue, #015FFB)',
  },

  inputDiv: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--Spacing-space-7, 12px)',
    alignSelf: 'stretch',
  },
  buttonDiv: {
    marginTop: '16px',
  },
  buttonHtml: {
    marginTop: '10px',
    float: 'right',
  },
  textArea: {
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    maxHeight: '400px',
    overflowY: 'auto',
  },
})

export default styles
